import { FC } from 'react'

import clsx from 'clsx'

const activeClass = 'text-actionAccent-600 hover:text-actionAccentHover-500'
export const MenuItem: FC<{
  isActive: boolean
  onClick: () => void
  className?: string
  title?: string
}> = ({ onClick, isActive, children, className, title }) => (
  <button
    title={title}
    type="button"
    onClick={onClick}
    className={clsx(
      'flex w-5 h-5 items-center hover:bg-surface-100',
      className,
      {
        [activeClass]: isActive,
      },
    )}
  >
    {children}
  </button>
)
